import { ThumbsUp, ThumbsDown } from 'lucide-react';
import { useChatStore } from '../../store/chatStore';
import { chatApi } from '../../lib/api';

function FeedbackBar({ messageId }) {
  const {
    messages,
    activeRole,
    activeSessionId,
    setFeedback,
  } = useChatStore();

  const msg = messages[activeRole]?.find(
    (m) => m.id === messageId
  );

  if (!msg) return null;

  if (msg.feedbackSubmitted) {
    return (
      <div
        className="mt-3 pt-3"
        style={{ borderTop: '1px solid #e2e8f0' }}
      >
        <p
          className="text-[12px]"
          style={{ color: '#22c55e' }}
        >
          ✓ Thanks for your feedback!
        </p>
      </div>
    );
  }

  const handleFeedback = async (action) => {
    // 1. Optimistic UI update
    setFeedback(messageId, action);

    // 2. Send feedback to backend (non-blocking)
    try {
      await chatApi.submitFeedback({
        session_id: activeSessionId || 'unknown',
        query: msg.originalQuery || msg.content,
        answer: msg.content,
        sources: (msg.sources || []).map((s) => ({
          type: s.type || 'Knowledge Base',
          title: s.title || '',
          category: s.category || '',
          sheet: '',
          sharepointUrl: s.sharepointUrl || '',
          websiteUrl: s.websiteUrl || '',
          description: s.description || '',
          detail: '',
        })),
        user_action: action,
      });
    } catch (err) {
      console.error(
        '[FeedbackBar] Failed to submit feedback:',
        err
      );
    }
  };

  return (
    <div
      className="mt-3 pt-3 flex items-center gap-2"
      style={{ borderTop: '1px solid #e2e8f0' }}
    >
      <span
        className="text-[12px]"
        style={{ color: '#ffffff', fontWeight: 600 }}
      >
        Was this helpful?
      </span>

      <button
        className="flex items-center gap-1 px-3 py-1 rounded-full text-[12px] transition-colors"
        style={{
          background: 'rgba(150, 230, 178, 1)',
          border: '1px solid rgba(150, 230, 178, 1)',
          color: '#106030',
        }}
        onClick={() => handleFeedback('helpful')}
        onMouseEnter={(e) =>
        (e.currentTarget.style.background =
          'rgba(150,230,178, 1)')
        }
        onMouseLeave={(e) =>
        (e.currentTarget.style.background =
          'rgba(150,230,178, 1)')
        }
      >
        <ThumbsUp size={12} /> Yes
      </button>

      <button
        className="flex items-center gap-1 px-3 py-1 rounded-full text-[12px] transition-colors"
        style={{
          background: 'rgba(242,176,176,1)',
          border: '1px solid rgba(242,176,176,1)',
          color: '#dc2626',
        }}
        onClick={() => handleFeedback('not_helpful')}
        onMouseEnter={(e) =>
        (e.currentTarget.style.background =
          'rgba(242,176,176,1)')
        }
        onMouseLeave={(e) =>
        (e.currentTarget.style.background =
          'rgba(242,176,176,1)')
        }
      >
        <ThumbsDown size={12} /> No
      </button>
    </div>
  );
}

export default FeedbackBar;
